import { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Dropdown, Tab, Nav, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  get_HoroNameDrpData,
  get_HoroScopeSingleData,
  get_HoroscopeData,
} from "../../../store/actions/CommanAction";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";

import DataTable from "react-data-table-component";
import swal from "sweetalert";
import { customStyles } from "../Utility/Utility";

import { EditorState, ContentState, convertFromHTML } from "draft-js";

import "ckeditor5/ckeditor5.css";
import Loader from "../Loader/Loader";
import ReactQuill from "react-quill-new";
import { he } from "date-fns/locale";

const Horoscope = () => {
  const dispatch = useDispatch();
  const customerID = Number(sessionStorage.getItem("ID"));
  const HoroData = useSelector((state) => state.feedBackReducer.HoroData);
  const HoroScopeSingleData = useSelector(
    (state) => state.feedBackReducer.HoroScopeSingleData
  );
  const HoroScopeNameData = useSelector(
    (state) => state.feedBackReducer.HoroScopeNameData
  );

 
  const [IsActive, setIsActive] = useState(true);
  const [postModal, setPostModal] = useState(false);

  const [EditValue, setEditValue] = useState();
  const [HoroID, setHoroID] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  const [loading, setloading] = useState(false);
  const[HoroEditID,setHoroIDEdit]=useState("")

  const [addFormData, setaddFormData] = useState({
    HoroscopeName: "",
    HoroscopeId: "",
    Shortdescription: "",
    Description: "",
    Horoscopetype: "",
    LuckyNumber: "",
    LuckyColor: "",
    CreatedByUser: "1",
    DescriptionDoc: "",
    FaqCategory: "",
    HoroscopeDetailsHTML: "",
  });

  const categoryOptions = [
    { value: "Free Kundli", label: "Free Kundli" },
    { value: "Kundli Matching", label: "Kundli Matching" },
    { value: "Horoscope", label: "Horoscope" },
     { value: "Love Calculator", label: "Love Calculator" },
     { value: "Horoscope Home", label: "Horoscope Home" },
  ];

  useEffect(() => {
    dispatch(get_HoroNameDrpData());
  }, []);

  useEffect(() => {
    if (IsActive) {
      dispatch(get_HoroscopeData("1", setloading));
    } else {
      dispatch(get_HoroscopeData("0", setloading));
    }
  }, [IsActive, IsActive]);

  const Reset = () => {
    setaddFormData({
      ...addFormData,
      HoroscopeName: "",
      HoroscopeId: "",
      Shortdescription: "",
      Description: "",
      Horoscopetype: "",
      LuckyNumber: "",
      LuckyColor: "",
      DescriptionDoc: "",
      FaqCategory: "",
      HoroscopeDetailsHTML: "",
    });
    setEditorState(() => EditorState.createEmpty());
  };

  useEffect(()=>{
    if(EditValue && EditValue.length>0){
      // setHoroID(EditValue[0]?.ID)
      setHoroIDEdit(EditValue[0]?.ID)
     
    }
  },[EditValue])
  const ChangeDropDown = (e, name) => {
    setaddFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: e ? e.value : null,
        HoroscopeName: e ? e.label : "",
      };
      return updatedData;
    });
  };

  const AddformData = async () => {
    const val = {
      HoroscopeName: addFormData.HoroscopeName,
      HoroscopeDetail: addFormData.Description,
      Type: addFormData.FaqCategory,
      HoroscopeDetailsHTML: addFormData.HoroscopeDetailsHTML,
      CreatedByUser: "1",
    };

    if (addFormData.Description === "") {
      swal("Oops", "Please fill in the  Detail Description.", "error");
      return;
    }
    if (addFormData.Type === "") {
      swal("Oops", "Please fill in the  Category.", "error");
      return;
    }

    const res = await AddUpdate(
      "HoroscopeDetails/Insert_HoroscopeDetails",
      val
    );
    setPostModal(false);
    swal("Good job!", "Successfully Added", "success");
    dispatch(get_HoroscopeData(IsActive, setloading));
    Reset();
  };

  const UpdateHoro = async (e) => {
    e.preventDefault();
    let error = false;
    let errorMsg = "";
    if (addFormData.Description === "") {
      swal("Oops", "Please fill in the  Detail Description.", "error");
      return;
    }
    if (addFormData.Type === "") {
      swal("Oops", "Please fill in the  Category.", "error");
      return;
    }
    const val = {
      HoroscopeName: addFormData.HoroscopeName,
      HoroscopeDetail: addFormData.Description,
      Type: addFormData.FaqCategory,
      HoroscopeDetailsHTML: addFormData.HoroscopeDetailsHTML,
      CreatedByUser: "1",
      ModifiedByUser: customerID,
      ID: HoroEditID,
    };
    if (!error) {
      await AddUpdate("HoroscopeDetails/Update_HoroscopeDetails", val);
      swal("Good job!", "Successfully Updated", "success");
      dispatch(get_HoroscopeData(IsActive, setloading));
      setEditModal(false);
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  useEffect(() => {
    if (HoroScopeSingleData) {
      setEditValue(HoroScopeSingleData);
    }
  }, [HoroScopeSingleData]);

  const handleEditClick = (row) => {
    dispatch(get_HoroScopeSingleData(row?.ID));

    setEditModal(true);
  };

  useEffect(() => {
    if (EditValue && EditValue.length > 0) {
    
      setaddFormData({
        ...addFormData,
        HoroID: HoroID,
        HoroscopeName: EditValue[0]?.HoroscopeName,
        HoroscopeId: EditValue[0]?.ID,
        Shortdescription: EditValue[0]?.Shortdescription,
        Description: EditValue[0]?.HoroscopeDetails,
        DescriptionDoc: EditValue[0]?.HoroscopeDetailsHTML,
        Horoscopetype: EditValue[0]?.Horoscopetype,
        LuckyNumber: EditValue[0]?.LuckyNumber,
        HoroscopeDetailsHTML: EditValue[0]?.HoroscopeDetailsHTML || "",
        LuckyColor: EditValue[0]?.LuckyColor,

        FaqCategory: EditValue[0]?.Type,
      });
      if (EditValue[0].HoroscopeDetailsHTML?.trim()) {
        setEditorState(
          EditorState.createWithContent(
            ContentState.createFromBlockArray(
              convertFromHTML(
                EditValue[0].HoroscopeDetailsHTML ? (
                  EditValue[0].HoroscopeDetailsHTML?.trim()
                ) : (
                  <p></p>
                )
              )
            )
          )
        );
      }
    }
  }, [EditValue]);

  const handleToggleStatusClick = async (ID, currentStatus, isActiveValue) => {
    const postData = {
      ID: ID,
      DeleteByUser: customerID,
      IsActive: isActiveValue,
    };
    await AddUpdate("HoroscopeDetails/Delete_HoroscopeDetails", postData);
    dispatch(get_HoroscopeData(currentStatus ? "1" : "0", setloading));
    swal(
      "Good job!",
      `Successfully ${isActiveValue === "1" ? "Active" : "Inactive"}`,
      "success"
    );
  };

  const columns = [
    {
      name: "FaQ Type",
      selector: (row) => (row.Type ? row.Type : "null"),
      sortable: true,
    },

    {
      name: "Detail Description",
      selector: (row) => (row.HoroscopeDetails ? row.HoroscopeDetails : "null"),
      sortable: true,
      format: (row) => (
        <>
          {row?.HoroscopeDetails ? row?.HoroscopeDetails.substring(0, 20) : ""}
          {row?.HoroscopeDetails?.length > 20 ? "  . . ." : null}{" "}
        </>
      ),
    },

    {
      name: "Date",
      selector: (row) =>
        row.CreatedDtTm ? new Date(row.CreatedDtTm).toLocaleDateString() : "",
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 50 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item onClick={() => handleEditClick(row)}>
                  Edit
                </Dropdown.Item>
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(row.ID, true, "0");
                  }}
                >
                  Inactive
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];
  const columns1 = [
    {
      name: "FaQ Type",
      selector: (row) => (row.Type ? row.Type : "null"),
      sortable: true,
    },

    {
      name: "Detail Description",
      selector: (row) => (row.HoroscopeDetails ? row.HoroscopeDetails : "null"),
      sortable: true,
      format: (row) => (
        <>
          {row?.HoroscopeDetails ? row?.HoroscopeDetails.substring(0, 20) : ""}
          {row?.HoroscopeDetails?.length > 20 ? "  . . ." : null}{" "}
        </>
      ),
    },

    {
      name: "Date",
      selector: (row) =>
        row.CreatedDtTm ? new Date(row.CreatedDtTm).toLocaleDateString() : "",
      sortable: true,
    },

    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 0 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 5 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(row.ID, false, "1");
                  }}
                >
                  Active
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ header: 1 }, { header: 2 }, { header: 3 }],
      [{ font: [] }],
      [{ size: [] }],

      ["bold", "italic", "underline", "strike"],
      [{ script: "sub" }, { script: "super" }],
      [{ color: [] }, { background: [] }],

      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],

      ["blockquote", "code-block"],

      ["link", "image", "video", "formula"],

      ["clean"],
    ],
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "script",
    "color",
    "background",
    "align",
    "list",
    "bullet",
    "indent",
    "blockquote",
    "code-block",
    "link",
    "image",
    "video",
    // "formula",
  ];

  return (
    <>
      <Tab.Container defaultActiveKey="All">
        <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
          <div className="card-action coin-tabs mb-2">
            <Nav as="ul" className="nav nav-tabs" role="tablist">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  className="nav-link"
                  eventKey="All"
                  onClick={(currentStatus) => {
                    setIsActive(true);
                  }}
                >
                  Active
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  className="nav-link"
                  eventKey="Inactive"
                  onClick={(currentStatus) => {
                    setIsActive(false);
                  }}
                >
                  Inactive
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <Link
            to={"#"}
            className="btn btn-primary font-w600 mb-2 "
            onClick={() => {
              setPostModal(true);
              Reset();
            }}
          >
            + New FaQ
          </Link>
        </div>
        <div className="row ">
          <div className="col-xl-12">
            <div className="">
              <div className=" p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="mb-sm-5 d-flex flex-wrap align-items-center text-head">
                      <Modal
                        className="modal fade "
                        size="xl"
                        show={postModal}
                        onHide={() => setPostModal(false)}
                        backdrop="static"
                      >
                        <form>
                          <div className="modal-header">
                            <h4 className="modal-title fs-20">Add FaQ</h4>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setPostModal(false)}
                              data-dismiss="modal"
                            ></button>
                          </div>
                          <div className="modal-body p-3">
                            <i
                              className="flaticon-cancel-12 close"
                              data-dismiss="modal"
                            ></i>
                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Category{" "}
                                      <span className="text-danger star-error">
                                        *
                                      </span>
                                    </label>
                                    <Select
                                      name="FaqCategory"
                                      value={
                                        categoryOptions.find(
                                          (obj) =>
                                            obj.value ===
                                            addFormData?.FaqCategory
                                        ) || null
                                      }
                                      options={categoryOptions}
                                      onChange={(e) =>
                                        setaddFormData((prev) => ({
                                          ...prev,
                                          FaqCategory: e ? e.value : "",
                                        }))
                                      }
                                      placeholder="Select Category.."
                                      isClearable={true}
                                      required
                                    />
                                  </div>

                                  {addFormData.FaqCategory === "Horoscope" && (
                                    <div className="form-group">
                                      <label className="form-label">
                                        Horoscope Name
                                      </label>
                                      <Select
                                        name="HoroscopeId"
                                        value={
                                          HoroScopeNameData?.find(
                                            (obj) =>
                                              obj.value ===
                                              addFormData?.HoroscopeId
                                          ) || null
                                        }
                                        options={HoroScopeNameData}
                                        onChange={(e) =>
                                          ChangeDropDown(
                                            e,
                                            "HoroscopeId",
                                            "HoroscopeName"
                                          )
                                        }
                                        placeholder="Select Horoscope.."
                                        isClearable={true}
                                        required
                                      />
                                    </div>
                                  )}
                                </div>

                                <label className="form-label">
                                  Detail Description
                                  <span className="text-danger star-error">
                                    *
                                  </span>
                                </label>

                                <div className="custom-ekeditor">
                                  <ReactQuill
                                    value={addFormData.HoroscopeDetailsHTML}
                                    onChange={(
                                      value,
                                      delta,
                                      source,
                                      editor
                                    ) => {
                                      const plainText = editor
                                        ?.getText()
                                        .trim();

                                      setaddFormData((prevState) => ({
                                        ...prevState,
                                        HoroscopeDetailsHTML: value,
                                        Description: plainText,
                                      }));
                                    }}
                                    modules={modules}
                                    formats={formats}
                                    theme="snow"
                                    placeholder="Write something..."
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={AddformData}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setPostModal(false);
                                Reset();
                              }}
                              className="btn btn-danger"
                            >
                              <i className="flaticon-delete-1"></i> Close
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>
                    <Modal
                      className="modal fade "
                      size="xl"
                      show={editModal}
                      onHide={setEditModal}
                      backdrop="static"
                    >
                      <div className="" role="document">
                        <div className="">
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">
                                Edit Horoscope
                              </h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setEditModal(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>
                              <div className="add-contact-box">
                                <div className="add-contact-content">
                                  <div className="form-group ">
                                    <label className="form-label">
                                      Category{" "}
                                      <span className="text-danger star-error">
                                        *
                                      </span>
                                    </label>
                                    <Select
                                      name="FaqCategory"
                                      value={
                                        categoryOptions.find(
                                          (obj) =>
                                            obj.value ===
                                            addFormData?.FaqCategory
                                        ) || null
                                      }
                                      options={categoryOptions}
                                      onChange={(e) =>
                                        setaddFormData((prev) => ({
                                          ...prev,
                                          FaqCategory: e ? e.value : "",
                                        }))
                                      }
                                      placeholder="Select Category.."
                                      isClearable={true}
                                      required
                                    />

                                    {addFormData.FaqCategory ===
                                      "Horoscope" && (
                                      <div className="form-group">
                                        <label className="form-label">
                                          Horoscope Name
                                        </label>

                                        <Select
                                          name="HoroscopeId"
                                          value={
                                            HoroScopeNameData?.find(
                                              (obj) =>
                                                obj.label ===
                                                addFormData?.HoroscopeName
                                            ) || null
                                          }
                                          options={HoroScopeNameData}
                                          onChange={(e) =>
                                            setaddFormData((prev) => ({
                                              ...prev,
                                              HoroscopeId: e ? e.value : null,
                                              HoroscopeName: e ? e.label : "",
                                            }))
                                          }
                                          placeholder="Select Horoscope.."
                                          isClearable={true}
                                          required
                                        />
                                      </div>
                                    )}
                                  </div>
                                  <div className="custom-ekeditor">
                                    <ReactQuill
                                      value={addFormData.HoroscopeDetailsHTML}
                                      onChange={(
                                        value,
                                        delta,
                                        source,
                                        editor
                                      ) => {
                                        const plainText = editor
                                          ?.getText()
                                          .trim();

                                        setaddFormData((prevState) => ({
                                          ...prevState,
                                          HoroscopeDetailsHTML: value,
                                          Description: plainText,
                                        }));
                                      }}
                                      modules={modules}
                                      formats={formats}
                                      theme="snow"
                                      placeholder="Write something..."
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={UpdateHoro}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setEditModal(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                {" "}
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>
                    <div className="col-12 mt-2">
                      {loading ? (
                        <Loader />
                      ) : (
                        <DataTable
                          dense
                          data={HoroData}
                          columns={columns}
                          selectableRowsHighlight
                          pagination
                          onRowClicked={(row) => {}}
                          fixedHeader
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />
                      )}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Inactive">
                    <div className="row">
                      <div className="col-12 mt-2">
                        {loading ? (
                          <Loader />
                        ) : (
                          <DataTable
                            dense
                            data={HoroData}
                            columns={columns1}
                            selectableRowsHighlight
                            highlightOnHover
                            pagination
                            onRowClicked={(row) => {}}
                            fixedHeader
                            persistTableHead={true}
                            noDataComponent={"There are no data to display"}
                            customStyles={customStyles}
                          />
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};

export default Horoscope;
